module.exports = __webpack_public_path__ + "img/second_zhTc.06d597b0.png";